export const GET_IN_AUTH_TOKEN_COOKIE_KEY = 'get-in-token';

export const IDS_TO_HIDE_PREDICTION = ['VknMm06O']
